import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { RecentSession } from '@pages/professional-services/models/recent-sessions/recent-session.interface';

@Injectable({
  providedIn: 'root',
})
export class ProfessionalServicesRecentSessionsService {
  private readonly httpClient = inject(HttpClient);

  getRecentSessions(): Observable<RecentSession[]> {
    const url = 'api/v1/professional-services-dashboard/recent-sessions';

    return this.httpClient.get<RecentSession[]>(environment.portalApiUrl + url);
  }
}
